import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { UtilService } from '../../services/util.service';
import {
    CustomerTeamType
    , Employee
    , SearchCustomer
    , SearchCustomerTeam
    , SearchEmployeeGroup
} from '../../models/models';

@Component({
    selector: 'customer-team-assigned',
    templateUrl: './customer-team-assigned.component.html',
    standalone: false
})
export class CustomerTeamAssigned implements OnChanges, OnInit {
    @Input() customerID: number = 0;
    @Input() pageType: string = "";
    @Input() customerStatus: string = "";

    public employeeList: Employee[] = [];
    public employeeGroupList: SearchEmployeeGroup[] = [];
    public searchCustomerTeamList: SearchCustomerTeam[] = [];
    public customerTeamTypeList: CustomerTeamType[] = [];
    public searchCustomer: SearchCustomer = {} as SearchCustomer;
    public isCRMAdmin: boolean = false;

    constructor(private crmService: CRMService, private employeeService: EmployeeService, private utilService: UtilService) {
    }

    ngOnInit() {
        this.isCRMAdmin = this.getIsCRMAdmin();
        this.getEmployees();
        this.getCustomerTeamTypes();
        this.getSearchEmployeeGroups();
    }

    ngOnChanges() {
        this.getCustomer();
    }

    private getIsCRMAdmin() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('CRM Admin') > -1) return true;
        }

        return false;
    }

    private getEmployees() {
        this.utilService.isLoading = true;
        this.employeeService.getActiveEmployees().subscribe(result => {
            this.utilService.isLoading = false;
            this.employeeList = result;
            this.employeeList = this.employeeList.sort((left, right): number => {
                if (left.fullName < right.fullName) return -1;
                if (left.fullName > right.fullName) return 1;
                return 0;
            });
        });
    }

    private getCustomer() {
        this.crmService.getSearchCustomerByID(this.customerID).subscribe(result => {
            this.searchCustomer = result.resultCollection[0];
            this.getSearchCustomerTeam();
        });
    }

    private getCustomerTeamTypes() {
        this.utilService.isLoading = true;
        this.crmService.getCustomerTeamTypes().subscribe(result => {
            this.utilService.isLoading = false;
            this.customerTeamTypeList = result.resultCollection;
            this.customerTeamTypeList = this.customerTeamTypeList.sort((left, right): number => {
                if (left.description < right.description) return -1;
                if (left.description > right.description) return 1;
                return 0;
            });
        });
    }

    private getSearchEmployeeGroups() {
        this.utilService.isLoading = true;
        this.employeeService.getSearchEmployeeGroups().subscribe(result => {
            this.utilService.isLoading = false;
            this.employeeGroupList = result.resultCollection;
            this.employeeGroupList = this.employeeGroupList.sort((left, right): number => {
                if (left.firstName + ' ' + left.lastName < right.firstName + ' ' + right.lastName) return -1;
                if (left.firstName + ' ' + left.lastName > right.firstName + ' ' + right.lastName) return 1;
                return 0;
            });
        });
    }

    public getEmployeeListByGroupID(groupID: number) {
        if (this.employeeGroupList.length > 0) {
            //console.log("getEmployeeListByGroupID", groupID);
            if (groupID > 0) {
                var group = this.employeeGroupList.filter(t => t.groupID == groupID);
                if (group != null) {
                    return group;
                }
                else {
                    return this.employeeList;
                }
            }
            else {
                return this.employeeList;
            }
        }
    }

    private getSearchCustomerTeam() {
        this.utilService.isLoading = true;
        this.crmService.getSearchCustomerTeamByCustomerID(this.customerID).subscribe(result => {
            this.utilService.isLoading = false;
            this.searchCustomerTeamList = result.resultCollection;
            this.searchCustomerTeamList = this.searchCustomerTeamList.filter(t => t.isEmployeeActive == true);
        });
    }

    public isEmployeeCustomerTeamType(customerTeamTypeID: number, employeeID: number) {
        var idx = this.searchCustomerTeamList.findIndex(t => t.customerTeamTypeID == customerTeamTypeID && t.employeeID == employeeID);
        //console.log("isEmployeeCustomerTeamType", teamTypeID, employeeID, idx);
        if (idx >= 0) {
            return true;
        }
        else {
            return false;
        }
    }

    public setEmployeeCustomerTeamMap(customerTeamTypeID: number, evt: any) {
        var employeeID: number = 0;
        if (evt.target) {
            employeeID = evt.target.value;
        }
        this.utilService.isLoading = true;
        var lastModifiedByEmployeeID = localStorage.getItem('EmployeeId') == null ? -1 : parseInt(localStorage.getItem('EmployeeId')!);
        this.crmService.saveCustomerTeamMap(this.customerID, customerTeamTypeID, employeeID, lastModifiedByEmployeeID).subscribe(result => {
            this.utilService.isLoading = false;
            console.log("setEmployeeCustomerTeamMap", customerTeamTypeID, employeeID, evt, result);
        });
    }
}
